import type { AnalyticsState } from '../types';

export const LOGGED_IN = 'loggedin';
export const LOGGED_OUT = 'loggedout';

export interface UserProps {
  authenticated?: boolean;
  trackingId?: string;
  externalId?: string;
  _id?: string;
  isUnifiedSite: boolean;
}

export const userReducer = (
  state: AnalyticsState,
  props: UserProps,
): AnalyticsState => {
  const { trackingId, externalId, _id, isUnifiedSite } = props;

  return {
    ...state,
    profileGuid: trackingId,
    loginId: _id,
    ...(!isUnifiedSite && { legacyCandidateId: externalId }),
    isLoggedIn: Boolean(_id || externalId),
  };
};
